import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Typography } from '@sequelae/lore-core';
import { useNavigationMode } from '../../contexts/NavigationModeContext';
import { NavigationModeToggle } from '../../components/NavigationModeToggle';
import { NavigationTestButtons } from '../../components/NavigationTestButtons';
import '../../styles/shared-styles.css';
import '../../styles/about.css';
import '../../styles/ios-styles.css';

export const PrivacyIOS = () => {
  const navigate = useNavigate();
  const { isNativeMode } = useNavigationMode();

  return (
    <div className="screen ios">
      <div className="shared-container">
        <div className="ios-container">
          <header className="ios-header">
            {!isNativeMode && (
              <Button onClick={() => navigate(-1)} className="ios-back-button" variant="text">
                <svg
                  width="13"
                  height="21"
                  viewBox="0 0 13 21"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10 2L3 10.5L10 19"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                  />
                </svg>
                <Typography variant="body" className="ml-auto">
                  About
                </Typography>
              </Button>
            )}
            <Typography variant="h1" className="ios-header-title">
              Privacy Policy
            </Typography>
            <div
              style={{
                padding: '0 var(--spacing-space-2)',
                marginLeft: 'auto',
              }}
            >
              <NavigationModeToggle />
            </div>
          </header>

          <div className="iframe-container-ios">
            <iframe
              src="https://www.lore.co/privacypolicy"
              title="Privacy Policy"
              className="iframe-fullscreen"
            />
          </div>
          <div className="navigation-test-spacer">
            <NavigationTestButtons />
          </div>
        </div>
      </div>
    </div>
  );
};
